import React from "react";
import Footer from "../Templete/Footer";
import Header from "../Templete/Header";

const ComplianceAndSecurity = () => {
  return (
    <>
      <Header />

      {/* Hero Start */}
      <section className="bg-half-170 bg-light d-table w-100">
        <div className="container">
          <div className="row mt-5 justify-content-center">
            <div className="col-lg-12 text-center">
              <div className="pages-heading">
                <h1 className="title mb-3" style={{ fontSize: "2.5rem" }}>
                  Compliance & Security
                </h1>
                <p className="text-muted para-desc mx-auto mb-0">
                  Protecting your data with enterprise-grade security measures
                  and regulatory compliance
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Shape Start */}
      <div className="position-relative">
        <div className="shape overflow-hidden text-white">
          <svg
            viewBox="0 0 2880 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
              fill="currentColor"
            />
          </svg>
        </div>
      </div>

      {/* Main Content Section */}
      <section className="section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <div className="card shadow rounded border-0">
                <div className="card-body p-4 p-sm-5">
                  {/* Introduction */}
                  <div className="row justify-content-center mb-5">
                    <div className="col-lg-10 text-center">
                      <h2 className="text-dark mb-3">
                        Our Security Commitment
                      </h2>
                      <p className="text-muted mb-0">
                        Formax IT Solutions Private Limited (operating as FORMAX
                        PAY) is committed to maintaining the highest standards
                        of security and compliance to protect our clients' data
                        and ensure the integrity of our services.
                      </p>
                    </div>
                  </div>

                  <hr className="my-5" />

                  {/* Company Information */}
                  <div className="row mb-5">
                    <div className="col-md-4">
                      <div className="card border-0 bg-light rounded p-4 h-100">
                        <div className="card-body text-center">
                          <div
                            className="icon text-primary rounded-circle d-inline-flex align-items-center justify-content-center bg-soft-primary mb-3"
                            style={{ width: "60px", height: "60px" }}
                          >
                            <i className="uil uil-building h4 mb-0"></i>
                          </div>
                          <h5 className="card-title">Legal Entity</h5>
                          <p className="text-muted mb-0">
                            Formax IT Solutions Private Limited
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4 mt-4 mt-md-0">
                      <div className="card border-0 bg-light rounded p-4 h-100">
                        <div className="card-body text-center">
                          <div
                            className="icon text-primary rounded-circle d-inline-flex align-items-center justify-content-center bg-soft-primary mb-3"
                            style={{ width: "60px", height: "60px" }}
                          >
                            <i className="uil uil-shield-check h4 mb-0"></i>
                          </div>
                          <h5 className="card-title">Security Focus</h5>
                          <p className="text-muted mb-0">
                            Data protection, encryption, and secure
                            infrastructure
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4 mt-4 mt-md-0">
                      <div className="card border-0 bg-light rounded p-4 h-100">
                        <div className="card-body text-center">
                          <div
                            className="icon text-primary rounded-circle d-inline-flex align-items-center justify-content-center bg-soft-primary mb-3"
                            style={{ width: "60px", height: "60px" }}
                          >
                            <i className="uil uil-balance-scale h4 mb-0"></i>
                          </div>
                          <h5 className="card-title">Regulatory Compliance</h5>
                          <p className="text-muted mb-0">
                            Adherence to applicable Indian and international
                            regulations
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* PAN Service Authorization */}
                  <div className="row mb-5">
                    <div className="col-12">
                      <div className="card border-0 bg-primary bg-soft rounded">
                        <div className="card-body p-4">
                          <div className="row align-items-center">
                            <div className="col-md-2 text-center mb-3 mb-md-0">
                              <div
                                className="mx-auto bg-white rounded-circle d-flex align-items-center justify-content-center"
                                style={{ width: "70px", height: "70px" }}
                              >
                                <i className="uil uil-award text-primary h3 mb-0"></i>
                              </div>
                            </div>
                            <div className="col-md-10">
                              <h4 className="text-white mb-2">
                                Authorized Corporate PAN Service Agent
                              </h4>
                              <p className="text-white-50 mb-0">
                                Formax IT Solutions Private Limited is
                                authorized by{" "}
                                <strong>Protean eGov Technologies Ltd</strong> &{" "}
                                <strong>
                                  UTI Infrastructure Technology And Services
                                  Limited
                                </strong>{" "}
                                for appointing PAN service agent across PAN
                                India and providing PAN card services with
                                complete compliance and security.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Security Features */}
                  <div className="row mb-5">
                    <div className="col-12">
                      <h3 className="text-dark mb-4">Security Features</h3>
                    </div>

                    <div className="col-md-6 mt-3">
                      <div className="d-flex align-items-start">
                        <div
                          className="icon text-center rounded-circle bg-soft-primary me-3 d-flex align-items-center justify-content-center"
                          style={{
                            width: "50px",
                            height: "50px",
                            flexShrink: "0",
                          }}
                        >
                          <i className="uil uil-lock text-primary h5 mb-0"></i>
                        </div>
                        <div>
                          <h5 className="text-dark">Data Encryption</h5>
                          <p className="text-muted mb-0">
                            All sensitive data is encrypted both in transit and
                            at rest using industry-standard encryption
                            protocols.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 mt-3">
                      <div className="d-flex align-items-start">
                        <div
                          className="icon text-center rounded-circle bg-soft-primary me-3 d-flex align-items-center justify-content-center"
                          style={{
                            width: "50px",
                            height: "50px",
                            flexShrink: "0",
                          }}
                        >
                          <i className="uil uil-server-network text-primary h5 mb-0"></i>
                        </div>
                        <div>
                          <h5 className="text-dark">Secure Infrastructure</h5>
                          <p className="text-muted mb-0">
                            Our infrastructure is hosted on secure cloud
                            platforms with regular security updates and
                            monitoring.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 mt-4">
                      <div className="d-flex align-items-start">
                        <div
                          className="icon text-center rounded-circle bg-soft-primary me-3 d-flex align-items-center justify-content-center"
                          style={{
                            width: "50px",
                            height: "50px",
                            flexShrink: "0",
                          }}
                        >
                          <i className="uil uil-shield-exclamation text-primary h5 mb-0"></i>
                        </div>
                        <div>
                          <h5 className="text-dark">Access Controls</h5>
                          <p className="text-muted mb-0">
                            Role-based access controls and authentication
                            mechanisms ensure only authorized personnel access
                            sensitive systems.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 mt-4">
                      <div className="d-flex align-items-start">
                        <div
                          className="icon text-center rounded-circle bg-soft-primary me-3 d-flex align-items-center justify-content-center"
                          style={{
                            width: "50px",
                            height: "50px",
                            flexShrink: "0",
                          }}
                        >
                          <i className="uil uil-history text-primary h5 mb-0"></i>
                        </div>
                        <div>
                          <h5 className="text-dark">Regular Audits</h5>
                          <p className="text-muted mb-0">
                            We conduct regular security assessments and audits
                            to identify and address potential vulnerabilities.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Data Protection */}
                  <div className="row mb-5">
                    <div className="col-12">
                      <div className="card border-0 bg-primary bg-soft rounded">
                        <div className="card-body p-4">
                          <div className="row align-items-center">
                            <div className="col-md-8">
                              <h4 className="text-white">
                                Data Protection & Privacy
                              </h4>
                              <p className="text-white-50 mb-0">
                                We follow strict data protection protocols and
                                comply with applicable privacy laws to safeguard
                                user information.
                              </p>
                            </div>
                            <div className="col-md-4 text-md-end mt-3 mt-md-0">
                              <a
                                href="/privacy-policy"
                                className="btn btn-light"
                              >
                                Privacy Policy{" "}
                                <i className="uil uil-arrow-right ms-1"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Policies Section */}
                  <div className="row">
                    <div className="col-12">
                      <h3 className="text-dark mb-4">
                        Policies & Documentation
                      </h3>
                    </div>

                    <div className="col-md-6 mt-3">
                      <div className="card border rounded">
                        <div className="card-body p-3 text-center">
                          <div className="avatar-md mx-auto mb-3 d-flex align-items-center justify-content-center">
                            <div
                              className="avatar-title bg-light text-primary rounded-circle d-flex align-items-center justify-content-center"
                              style={{ width: "60px", height: "60px" }}
                            >
                              <i className="uil uil-file-contract h4 mb-0"></i>
                            </div>
                          </div>
                          <h6 className="text-dark">Privacy Policy</h6>
                          <a
                            href="/privacy-policy"
                            className="text-primary small"
                          >
                            View <i className="uil uil-arrow-right"></i>
                          </a>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 mt-3">
                      <div className="card border rounded">
                        <div className="card-body p-3 text-center">
                          <div className="avatar-md mx-auto mb-3 d-flex align-items-center justify-content-center">
                            <div
                              className="avatar-title bg-light text-primary rounded-circle d-flex align-items-center justify-content-center"
                              style={{ width: "60px", height: "60px" }}
                            >
                              <i className="uil uil-book-alt h4 mb-0"></i>
                            </div>
                          </div>
                          <h6 className="text-dark">Terms of Service</h6>
                          <a href="/terms" className="text-primary small">
                            View <i className="uil uil-arrow-right"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Contact Section */}
                  <div className="row mt-5 pt-4">
                    <div className="col-12">
                      <div className="card border-0 bg-light rounded">
                        <div className="card-body p-4 text-center">
                          <h4 className="text-dark mb-3">
                            Security Questions?
                          </h4>
                          <p className="text-muted mb-4">
                            Our security team is available to address any
                            concerns or questions about our security practices.
                          </p>
                          <a href="/contact-us" className="btn btn-primary">
                            Contact Security Team
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default ComplianceAndSecurity;
